import React from 'react';

import { HStack, Spinner, useToast } from '@chakra-ui/react';
import { useMutation } from 'react-query';
import { useParams, useHistory } from 'react-router-dom';

import { Icon } from 'components';
import { actions } from 'constants/table';
import { GeneralStatus } from 'enums/status';
import { AccessTypes, MethodTypes, RoleTypes } from 'enums/types';
import useActions from 'hooks/useActions';
import { useFormModal } from 'hooks/useFormModal';
import { policy } from 'polices';

const Actions = ({ row, refetch }) => {
  const { content } = useParams<GeneralRoute>();
  const { onOpen, setUpdateId, Form } = useFormModal(content);
  const { onDelete, onRestore } = useActions();
  const { push } = useHistory();
  const policies = policy(content);
  const toast = useToast();
  const { mutate, isLoading } = useMutation(onRestore, {
    onSuccess: refetch,
    onError: (error: any) => {
      toast({
        title: 'Ocorreu um erro.',
        description: error.message,
        status: 'error',
        duration: 5000,
        position: 'top-right',
        isClosable: true,
      });
    },
  });
  const trash = {
    disable: () => {
      if (row.original.status === GeneralStatus.Active) {
        onDelete(`/${content}/${row.original.id}`, row.original);
      } else {
        mutate(`/${content}/${row.original.id}`);
      }
    },
    delete: () => {
      onDelete(`/${content}/${row.original.id}`, row.original);
    },
  };

  const edit = {
    show: () => push(`/${content}/${row.original.id}`),
    modal: () => {
      setUpdateId(row.original.id);
      onOpen();
    },
  };
  if (row.original.type === RoleTypes.Default || row.original.isEditable === false) {
    return null;
  }

  return (
    <HStack
      spacing={2}
      color="gray.500">
      <Form onSuccess={refetch} />
      <Icon
        hidden={!actions[content].onEdit || policies(MethodTypes.Update) === AccessTypes.Disallow}
        onClick={edit[actions[content].onEdit]}
        cursor="pointer"
        name="edit"
      />
      {isLoading ? <Spinner size="sm" /> : (
        <Icon
          hidden={
            !actions[content].onTrash || policies(MethodTypes.disable) === AccessTypes.Disallow
          }
          onClick={trash[actions[content].onTrash]}
          cursor="pointer"
          name={row.original.status === GeneralStatus.Inactive ? 'trash-restore-alt' : 'trash-alt'}
        />
      )}
    </HStack>
  );
};

export default Actions;
